<div class="search-input-container">
	<div class="search-container">
		<div class="input-tag" *ngIf="selectedSearchTag != undefined">
			{{ labels[selectedSearchTag.label] ? labels[selectedSearchTag.label] : selectedSearchTag.label }}
		</div>
		<input
			[placeholder]="labels[searchPlaceholder] ? labels[searchPlaceholder] : searchPlaceholder"
			[value]="searchText"
			(focus)="handleSearchPlaceHolder('focus'); canOpenList()"
			(blur)="handleSearchPlaceHolder('blur'); openList = false"
			(keyup)="keyboardEventHandler($event)"
			(input)="backspaceCount = 0; tagOnHoverIndex = 0; searchText = $event.target.value; canOpenList()"
			id="searchInput"
			#searchInput />
		<label [htmlFor]="'searchInput'" (click)="fsearch()"><fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon></label>
	</div>
	<div
		[ngClass]="{ openListToLeft: openListToLeft, openListToTop: openListToTop }"
		class="list-container"
		*ngIf="selectedSearchTag == undefined && openList"
		#listContainer>
		<div
			class="tag"
			[ngClass]="{ hover: index == tagOnHoverIndex }"
			(mouseenter)="tagOnHoverIndex = index"
			(mousedown)="clickTag()"
			*ngFor="let tag of tags | callback: filterList; let index = index">
			<span>/{{ tag.tag }}</span>
			<span *ngIf="tag.label">({{ labels[tag.label] ? labels[tag.label] : tag.label }})</span>
		</div>
	</div>
</div>
